(() => {
  const productRoots = document.querySelectorAll('[data-product-root]');
  if (!productRoots.length) return;

  const hoverCapable = window.matchMedia('(hover: hover)');

  function formatMoney(cents = 0, currencyCode = 'USD') {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode
    }).format((Number(cents) || 0) / 100);
  }

  function updateToggleButtons(group, selectedOptions, variants) {
    const label = group.querySelector('[data-option-value-label]');
    const buttons = Array.from(group.querySelectorAll('[data-option-position][data-option-value]'));
    const optionPosition = Number(group.dataset.optionPosition) - 1;

    if (label) {
      label.textContent = selectedOptions[optionPosition] || '';
    }

    buttons.forEach((button) => {
      const buttonValue = button.dataset.optionValue;
      const optionIndex = Number(button.dataset.optionPosition) - 1;
      const isSelected = selectedOptions[optionIndex] === buttonValue;

      const hasAvailableCombination = variants.some((variant) => {
        if (!variant.available) return false;

        return variant.options.every((variantValue, index) => {
          if (index === optionIndex) return variantValue === buttonValue;
          return variantValue === selectedOptions[index];
        });
      });

      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', String(isSelected));
      button.disabled = !hasAvailableCombination;
    });
  }

  productRoots.forEach((root) => {
    const variantScript = root.querySelector('[data-product-variants]');
    if (!variantScript) return;

    let variants = [];

    try {
      variants = JSON.parse(variantScript.textContent);
    } catch (error) {
      console.error('Unable to parse product variants JSON', error);
      return;
    }

    const currencyCode = root.dataset.currency || 'USD';
    const masterSelect = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const addToCartButton = root.querySelector('[data-add-to-cart]');
    const addToCartText = root.querySelector('[data-add-to-cart-text]');
    const optionGroups = Array.from(root.querySelectorAll('[data-product-option-group]'));

    const slides = Array.from(root.querySelectorAll('.product-gallery__slide[data-media-id]'));
    const stageThumbs = Array.from(root.querySelectorAll('.product-gallery__thumb[data-media-target]'));
    const stage = root.querySelector('[data-gallery-open]');

    const gallery = root.querySelector('[data-product-gallery]');
    let galleryImagesPrewarmed = false;

    function preloadSlideImage(mediaId) {
      const slide = slides.find((item) => String(item.dataset.mediaId) === String(mediaId));
      if (!slide) return;

      const img = slide.querySelector('img');
      if (!img || img.dataset.preloaded === 'true') return;

      const preload = new Image();
      const src = img.currentSrc || img.src || img.getAttribute('src');
      const srcset = img.srcset || img.getAttribute('srcset');
      const sizes = img.sizes || img.getAttribute('sizes');

      if (srcset) preload.srcset = srcset;
      if (sizes) preload.sizes = sizes;
      if (src) preload.src = src;

      img.dataset.preloaded = 'true';
    }

    function prewarmGalleryImages() {
      if (galleryImagesPrewarmed) return;
      galleryImagesPrewarmed = true;

      slides.forEach((slide, index) => {
        if (index < 3) return;
        preloadSlideImage(slide.dataset.mediaId);
      });
    }

    const modal = root.querySelector('[data-gallery-modal]');
    const modalImage = root.querySelector('[data-gallery-modal-image]');
    const modalThumbs = Array.from(root.querySelectorAll('.product-gallery-modal__thumb[data-gallery-modal-target]'));
    const modalCloseButtons = root.querySelectorAll('[data-gallery-close]');
    const modalPrev = root.querySelector('[data-gallery-prev]');
    const modalNext = root.querySelector('[data-gallery-next]');
    const modalClose = root.querySelector('.product-gallery-modal__close');

    if (!masterSelect) return;

    let selectedOptions = [];
    let lockedMediaId = null;
    let lastFocusedElement = null;

    function getInitialVariant() {
      const selectedId = Number(masterSelect.value);
      return variants.find((variant) => Number(variant.id) === selectedId) || variants[0];
    }

    function getCurrentVariant() {
      return variants.find((variant) =>
        variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
      );
    }

    function getMediaIds() {
      return slides.map((slide) => String(slide.dataset.mediaId));
    }

    function getActiveMediaId() {
      const activeSlide = root.querySelector('.product-gallery__slide.is-active');
      return activeSlide ? String(activeSlide.dataset.mediaId) : null;
    }

    function scrollModalThumbIntoView(mediaId) {
      if (!modalThumbs.length) return;

      const activeThumb = modalThumbs.find(
        (thumb) => String(thumb.dataset.galleryModalTarget) === String(mediaId)
      );

      if (!activeThumb) return;

      activeThumb.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    function updateModalImage() {
      if (!modal || modal.hidden || !modalImage) return;

      const activeSlideImage = root.querySelector('.product-gallery__slide.is-active img');
      if (!activeSlideImage) return;

      modalImage.src = activeSlideImage.currentSrc || activeSlideImage.src;
      modalImage.alt = activeSlideImage.alt || '';
    }

    function updateThumbState(thumbList, dataKey, mediaId) {
      thumbList.forEach((thumb) => {
        const isActive = String(thumb.dataset[dataKey]) === String(mediaId);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', String(isActive));
      });
    }

    function setActiveMedia(mediaId, { lock = false, scrollModalThumbs = true } = {}) {
      if (!mediaId) return;

      preloadSlideImage(mediaId);

      const mediaIds = getMediaIds();
      const currentIndex = mediaIds.indexOf(String(mediaId));

      if (currentIndex > -1) {
        const prevId = mediaIds[currentIndex - 1];
        const nextId = mediaIds[currentIndex + 1];

        if (prevId) preloadSlideImage(prevId);
        if (nextId) preloadSlideImage(nextId);
      }

      slides.forEach((slide) => {
        const isActive = String(slide.dataset.mediaId) === String(mediaId);
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
      });

      updateThumbState(stageThumbs, 'mediaTarget', mediaId);
      updateThumbState(modalThumbs, 'galleryModalTarget', mediaId);

      if (lock) {
        lockedMediaId = String(mediaId);
      }

      updateModalImage();

      if (modal && !modal.hidden && scrollModalThumbs) {
        scrollModalThumbIntoView(mediaId);
      }
    }

    function syncOptionButtons() {
      optionGroups.forEach((group) => {
        updateToggleButtons(group, selectedOptions, variants);
      });
    }

    if (gallery) {
      gallery.addEventListener('mouseenter', prewarmGalleryImages, { once: true });
      gallery.addEventListener('focusin', prewarmGalleryImages, { once: true });
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(prewarmGalleryImages, { timeout: 1200 });
    } else {
      window.setTimeout(prewarmGalleryImages, 700);
    }

    function syncVariantState({ updateMedia = true } = {}) {
      const variant = getCurrentVariant();

      if (!variant) {
        if (addToCartButton) addToCartButton.disabled = true;
        if (addToCartText) addToCartText.textContent = 'Unavailable';
        syncOptionButtons();
        return;
      }

      masterSelect.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price, currencyCode);
      }

      if (addToCartButton && addToCartText) {
        addToCartButton.disabled = !variant.available;
        addToCartText.textContent = variant.available
          ? addToCartButton.dataset.availableLabel || 'Add to cart'
          : addToCartButton.dataset.soldoutLabel || 'Sold out';
      }

      if (updateMedia && variant.featured_media_id) {
        setActiveMedia(String(variant.featured_media_id), { lock: true });
      }

      syncOptionButtons();

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    function openModal() {
      if (!modal) return;

      lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      modal.hidden = false;
      document.body.classList.add('gallery-modal-open');
      updateModalImage();

      const activeMediaId = getActiveMediaId();
      if (activeMediaId) {
        scrollModalThumbIntoView(activeMediaId);
      }

      window.requestAnimationFrame(() => {
        if (modalClose) modalClose.focus();
      });
    }

    function closeModal() {
      if (!modal) return;

      modal.hidden = true;
      document.body.classList.remove('gallery-modal-open');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function navigateModal(direction) {
      const mediaIds = getMediaIds();
      if (!mediaIds.length) return;

      const activeMediaId = getActiveMediaId();
      const currentIndex = Math.max(mediaIds.indexOf(activeMediaId), 0);
      const nextIndex = (currentIndex + direction + mediaIds.length) % mediaIds.length;

      setActiveMedia(mediaIds[nextIndex], { lock: true });
    }

    function bindThumbInteractions(buttons, getMediaId) {
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const mediaId = getMediaId(button);
          setActiveMedia(mediaId, { lock: true });
        });

        button.addEventListener('mouseenter', () => {
          if (!hoverCapable.matches) return;
          const mediaId = getMediaId(button);
          setActiveMedia(mediaId, { lock: false, scrollModalThumbs: false });
        });

        button.addEventListener('mouseleave', () => {
          if (!hoverCapable.matches || !lockedMediaId) return;
          setActiveMedia(lockedMediaId, { lock: false, scrollModalThumbs: false });
        });
      });
    }

    const initialVariant = getInitialVariant();

    selectedOptions = initialVariant ? [...initialVariant.options] : [];

    if (initialVariant && initialVariant.featured_media_id) {
      lockedMediaId = String(initialVariant.featured_media_id);
    } else if (slides[0]) {
      lockedMediaId = String(slides[0].dataset.mediaId);
    }

    optionGroups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-option-position][data-option-value]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const optionIndex = Number(button.dataset.optionPosition) - 1;
          selectedOptions[optionIndex] = button.dataset.optionValue;
          syncVariantState({ updateMedia: true });
        });
      });
    });

    bindThumbInteractions(stageThumbs, (button) => button.dataset.mediaTarget);
    bindThumbInteractions(modalThumbs, (button) => button.dataset.galleryModalTarget);

    if (stage && modal) {
      stage.addEventListener('click', openModal);
    }

    if (modalPrev) {
      modalPrev.addEventListener('click', () => navigateModal(-1));
    }

    if (modalNext) {
      modalNext.addEventListener('click', () => navigateModal(1));
    }

    modalCloseButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowLeft') navigateModal(-1);
      if (event.key === 'ArrowRight') navigateModal(1);
    });

    syncVariantState({ updateMedia: false });

    if (lockedMediaId) {
      setActiveMedia(lockedMediaId, { lock: true });
    }
  });
})();